import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import DeletedUsersService from "@/services/api/deletedUsers";
import type { DeletedUsersResponse, DeletedUserSortBy } from "@/services/api/deletedUsers";
import type { SortOrder } from "@/services/api/incompleteUsers";

export const deletedUsersKeys = {
  all: ["deleted-users"] as const,
  list: (page: number, limit: number, sortOrder: SortOrder, sortBy?: DeletedUserSortBy, search?: string | null) =>
    [...deletedUsersKeys.all, { page, limit, sortOrder, sortBy, search: search ?? "" }] as const,
};

interface UseDeletedUsersParams {
  page: number;
  limit: number;
  sortOrder?: SortOrder;
  sortBy?: DeletedUserSortBy;
  search?: string | null;
  enabled?: boolean;
}

export function useDeletedUsers({
  page,
  limit,
  sortOrder = "desc",
  sortBy,
  search,
  enabled = true,
}: UseDeletedUsersParams) {
  return useQuery<DeletedUsersResponse>({
    queryKey: deletedUsersKeys.list(page, limit, sortOrder, sortBy, search),
    queryFn: async () => {
      try {
        return await DeletedUsersService.getDeletedUsers({
          limit,
          offset: (page - 1) * limit,
          search,
          sortBy,
          sortOrder,
        });
      } catch (error: any) {
        toast.error(error?.message || "Failed to fetch deleted users");
        throw error;
      }
    },
    placeholderData: (previousData) => previousData,
    enabled,
  });
}
